import { privateFetch } from "apis";
import { mapDefaultLinksToLinks } from "../helpers";
import { displayError, SecureLocalStorage } from "helpers";
import { isLoading } from "../../helpers/loadingActions";

// New App
export const removeApplication = (appId) => ({
  type: "REMOVE_APPLICATION",
  appId,
});

const setApplications = (applications) => ({
  type: "SET_APPLICATIONS",
  applications,
});

// Punchcard
export const setPunchCardsCopy = (cards) => ({
  type: "SET_PUNCH_CARDS_COPY",
  cards,
});

export const updatePunchCardCopy = (card) => ({
  type: "UPDATE_PUNCH_CARD_COPY",
  card,
});

export const addPunchCardCopy = (card) => ({
  type: "ADD_PUNCH_CARD_COPY",
  card,
});

// Coupons
export const setCouponsCopy = (coupons) => ({
  type: "SET_COUPONS_COPY",
  coupons,
});

export const addCouponCopy = (coupon) => ({
  type: "ADD_COUPON_COPY",
  coupon,
});

export const updateCouponCopy = (coupon) => ({
  type: "UPDATE_COUPON_COPY",
  coupon,
});

// Invoices
export const setInvoicesCopy = (invoices) => ({
  type: "SET_INVOICES_COPY",
  invoices,
});

export const addInvoiceCopy = (invoice) => ({
  type: "ADD_INVOICE_COPY",
  invoice,
});

export const updateInvoiceCopy = (invoice) => ({
  type: "UPDATE_INVOICE_COPY",
  invoice,
});

// Deals
export const setDealsCopy = (deals) => ({
  type: "SET_DEALS_COPY",
  deals,
});

export const addDealCopy = (deal) => ({
  type: "ADD_DEAL_COPY",
  deal,
});

export const updateDealCopy = (deal) => ({
  type: "UPDATE_DEAL_COPY",
  deal,
});

export const removeDealCopy = (deal) => ({
  type: "REMOVE_DEAL_COPY",
  deal,
});

// Store
export const setStoreItemsCopy = (storeItems) => ({
  type: "SET_STORE_ITEMS_COPY",
  storeItems,
});

export const addStoreCopy = (storeItem) => ({
  type: "ADD_STORE_ITEM_COPY",
  storeItem,
});

export const updateStoreItemCopy = (storeItem) => ({
  type: "UPDATE_STORE_ITEM_COPY",
  storeItem,
});

export const removeStoreItemCopy = (storeItem) => ({
  type: "REMOVE_STORE_ITEM_COPY",
  storeItem,
});

// Rewards
export const setRewardsCopy = (rewards) => ({
  type: "SET_REWARDS_COPY",
  rewards,
});

export const addRewardCopy = (reward) => ({
  type: "ADD_REWARD_COPY",
  reward,
});

export const updateRewardCopy = (reward) => ({
  type: "UPDATE_REWARD_COPY",
  reward,
});

export const removeRewardCopy = (reward) => ({
  type: "REMOVE_REWARD_COPY",
  reward,
});

export const resetApplications = () => ({
  type: "RESET_APPLICATIONS",
});

export const resetOtherThanApps = () => ({
  type: "RESET_OTHER_THAN_APPS",
});

export const updateApplicationLibrary = (application) => ({
  type: "UPDATE_APPLICATION_LIBRARY",
  application,
});

export const rmCachedBusinessPhoneNumber = (locationIdx, phoneIdx, appId) => ({
  type: "REMOVE_CACHED_PHONE_NUMBER",
  locationIdx,
  phoneIdx,
  appId,
});

export const isDeleting = (deleting) => ({
  type: "TOGGLE_DELETE_EDGE_CASE",
  deleting,
});

// get applications by userId
export const getApplicationsByUserId = () => (dispatch) => {
  const userId = SecureLocalStorage.getItem("userId");
  isLoading(true);

  return privateFetch(
    `${__BASE_API_URL__}/usersApplications?userId=${userId}&isAdmin=1`,
    {
      method: "GET",
    }
  )
    .then((apps) => {
      const workingApps = [];
      // console.log("original apps after api call");
      // console.log(apps);
      apps.forEach((a) => {
        // console.log("printing raw app templates");
        // console.log(a.unpublishedView);
        try {
          const view = JSON.parse(decodeURI(a.unpublishedView));
          const links = mapDefaultLinksToLinks(a.links);
          const oldAppCode = a.code;
          const { publishedView, ...storeAppInfo } = a;
          // console.log(publishedView);
          const publishedViews = JSON.parse(decodeURI(publishedView));
          const workingApp = {
            ...storeAppInfo,
            view,
            publishable: publishedView !== a.unpublishedView,
            publishedViews,
            links,
            oldAppCode,
          };
          workingApps.push(workingApp);
        } catch (e) {
          if (process.env.NODE_ENV !== "prod") console.log(e, a.name);
          displayError("Oops! Something went wrong with some listings!");
        }
      });
      // console.log("printing working apps");
      // console.log(workingApps);

      dispatch(setApplications(workingApps));
      isLoading(false);
    })
    .catch((error) => {});
};

export const deleteApp = (appId) => (dispatch) => {
  dispatch(isDeleting(true)); // this helps bypass the SaveProgress prompt
  return new Promise((resolve, reject) => {
    return privateFetch(`${__BASE_API_URL__}/application/${appId}`, {
      method: "DELETE",
    })
      .then((status) => {
        // remove app with appId in redux state
        dispatch(removeApplication(appId));
        resolve(status);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};
